import { useLayoutEffect, useState } from 'react';

export const useIsScrollable = (contentContainerRef, contentString) => {
  const [isScrollable, setIsScrollable] = useState(false);

  useLayoutEffect(() => {
    const element = contentContainerRef.current;
    if (!element) return;

    const updateIsScrollable = () =>
      setIsScrollable(element.scrollHeight - element.clientHeight > 1);

    updateIsScrollable();

    const resizeObserver = new ResizeObserver(updateIsScrollable);
    resizeObserver.observe(element);

    return () => resizeObserver.disconnect();
  }, [contentContainerRef, contentString]);

  return isScrollable;
};
